import client from './client';

/*
 * Fire-and-forget telemetry. Errors are swallowed so a failing emission can
 * never block the onboarding UX. Backend whitelists event names and skips
 * internal accounts.
 */
const recordOnboardingEvent = (name, meta = null) =>
	client.post('/api/onboarding/events', { event: name, ...(meta && { meta }) }).catch(() => {});

const getParseStatus = () => client.get('/api/profile/onboarding/parse-status');

const uploadOnboardingResume = (file, config = {}) => {
	const formData = new FormData();
	formData.append('file', file);
	return client.post('/api/onboarding/v3/resume', formData, config);
};

// Existing-user AutoApply flow (EN-777): the primary resume's analysis status, and the JSON
// twin of the onboarding Qualify step.
const startResumeAnalysis = () => client.post('/api/onboarding/resume-analysis');

const getResumeAnalysis = () => client.get('/api/onboarding/resume-analysis');

const submitQualification = (answers) => client.post('/api/onboarding/qualification', answers);

export {
	recordOnboardingEvent,
	getParseStatus,
	uploadOnboardingResume,
	startResumeAnalysis,
	getResumeAnalysis,
	submitQualification,
};
